// @flow

const NAMES = {
	TELEMEDICINE: 'Telemedicine',
	MEDICAL_REQUEST: 'MedicalRequest',
	BUY_WITH_DISCOUNT: 'BuyWithDiscount',
	EMERGENCY: 'Emergency',
	SECOND_OPINION: 'SecondOpinion',
	MED_ADVISOR: 'MedicalAdviser',
	WEB_CHAT: 'WebChat',
	GUARANTEE_LETTER: 'AgreeOnMedicalService',
	ARRANGE_VISIT: 'ArrangeVisit',
	PLANNED_HOSPITALIZATION: 'PlannedHospitalization',
	CALLING_DOCTOR: 'CallingDoctor',
	MEDICAL_CARE_ABROAD: 'MedicalCareAbroad',
	FAMILY_INSURANCE: 'FamilyInsurance',
	UPGRADE: 'InsuranceProgramUpgrade',
	DIGITAL_CLINIC: 'DigitalClinic',
	ASSISTANCE_TYPES_TAB: 'AssistanceTypesTab',
	LPUS_TAB: 'LpusTab',
	PROGRAM_TAB: 'InsuranceProgramTab',
	EMAIL_SENDING: 'EmailSending',
	SYMPTOM_CHECKER: 'SymptomChecker',
	LABORATORY_RESEARCH: 'LaboratoryResearch',
};

const STATUSES = {
	AVAILABLE: 'Available',
	NOT_AVAILABLE: 'NotAvailable',
};

/*eslint-disable max-len*/
const MESSAGES = {
	ACCESS_ERROR_MESSAGE: 'Доступ запрещен. Воспользоваться услугами телемедицины может только застрахованный по ДМС.',
	ACCESS_ERROR_EMERGENCY: 'Доступ запрещен. Воспользоваться услугой вызова скорой помощи может только застрахованный по ДМС.',
	ACCESS_ERROR_REQUEST: 'Доступ запрещен. Отправка обращений доступна только застрахованному по ДМС.',
	ACCESS_ERROR_SIMPLE: 'Доступ запрещен. Воспользоваться услугой может только застрахованный по ДМС.',
	ACCESS_ERROR_AGE: 'Доступ к услугам телемедицины через полис несовершеннолетнего временно ограничен. Вы можете воспользоваться телемедициной через полис законного представителя.',
	ACCESS_ERROR_CHAT: 'Что-то пошло не так. Попробуйте воспользоваться услугой позже.',
	ACCESS_ERROR_MED_ADVISOR: [
		'Доступ запрещен. ',
		'Воспользоваться онлайн-чатом может только застрахованный по ДМС.',
	].join(''),
	ACCESS_ERROR_ADMINISTRATIVE: 'Подача обращений по административному или техническому вопросу доступна только застрахованным по ДМС.',
};
/*eslint-enable max-len*/

/*eslint-disable max-len*/
const CONTENT: {[string]: any} = {
	[NAMES.TELEMEDICINE]: {
		desktopImage: 'https://old.rgs.ru/upload/medialibrary/acf/720x400_1_1_pogovorit_s_vrachom_onlayn.jpg',
		mobileImage: 'https://old.rgs.ru/upload/medialibrary/ab3/600x320_1_1_pogovorit_s_vrachom_onlayn.jpg',
		title: 'Согласие на обработку данных',
		text: 'Услуга требует согласия на обработку и передачу персональных данных, включая информацию о здоровье. Данные будут использованы только для оказания медицинских услуг',
		actionText: 'Продолжить',
	},
	[NAMES.MEDICAL_REQUEST]: {
		desktopImage: 'https://old.rgs.ru/upload/medialibrary/815/720x400_1_5_obratitsya_k_vrachu_kuratoru.jpg',
		mobileImage: 'https://old.rgs.ru/upload/medialibrary/815/720x400_1_5_obratitsya_k_vrachu_kuratoru.jpg',
		title: 'Обратиться к врачу-куратору',
		text: '<ul>\r\n\t<li>Возникли вопросы по программе ДМС?</li>\r\n\t<li>Не знаете в какую клинику записаться на консультацию?</li>\r\n\t<li>Необходимо организовать консультацию, диагностическое исследование или плановую госпитализацию?</li>\r\n</ul>\r\n</br>\r\nСвяжитесь с врачом-куратором для решения Ваших медицинских вопросов.',
		actionText: 'Написать врачу-куратору',
	},
	[NAMES.BUY_WITH_DISCOUNT]: {
		desktopImage: '',
		mobileImage: '',
		title: 'Купить на специальных условиях',
		text: 'Вам доступна Программа корпоративных привилегий - это программа лояльности для корпоративных застрахованных, по условиям которой Вы можете купить самые востребованные страховые продукты по сниженной стоимости для себя и своих близких.',
		actionText: 'Перейти',
	},
	[NAMES.EMERGENCY]: {
		desktopImage: 'https://old.rgs.ru/upload/medialibrary/ab2/720x400_1_2_skoraya_meditsinskaya_pomoshch.jpg',
		mobileImage: 'https://old.rgs.ru/upload/medialibrary/21c/600x320_1_2_skoraya_meditsinskaya_pomoshch.jpg',
		title: 'Вызвать скорую помощь',
		text: 'Для вызова скорой медицинской помощи Вам необходимо обратиться к специалистам круглосуточного медицинского контактного центра ПАО СК «Росгосстрах»:',
		actionText: 'Вызвать скорую',
	},
	[NAMES.SECOND_OPINION]: {
		desktopImage: 'https://old.rgs.ru/upload/medialibrary/842/720x400_1_3_poluchit_vtoroe_mnenie.jpg',
		mobileImage: 'https://old.rgs.ru/upload/medialibrary/485/600x320_1_3_poluchit_vtoroe_mnenie.jpg',
		title: 'Получить второе медицинское мнение',
		text: 'Получите врачебное заключение по Вашему клиническому диагнозу от лучших специалистов.<br/><br/>\r\nЗагрузите на платформу актуальную медицинскую документацию, сообщите Медсоветнику о желании воспользоваться услугой.<br/><br/>\r\nПосле получения результатов Медсоветник организует телемедицинскую консультацию с врачом, предоставившим заключение, в ходе которой Вы сможете задать врачу любые вопросы.',
		actionText: 'Получить услугу',
	},
	[NAMES.MED_ADVISOR]: {
		desktopImage: 'https://old.rgs.ru/upload/medialibrary/3b7/720x400_1_4_zadat_vopros_medsovetniku.jpg',
		mobileImage: 'https://old.rgs.ru/upload/medialibrary/55d/600x320_1_4_zadat_vopros_medsovetniku.jpg',
		title: 'Задать вопрос Медсоветнику',
		text: 'Информационная поддержка 24/7 по любым вопросам в области Здравоохранения:\r\n</br></br>\r\n<ul>\r\n\t<li>по объему услуг в рамках Программы ДМС</li>\r\n\t<li>по вопросам получения медицинской помощи <br>\r\n в системе ОМС (в т.ч. помощь в получении квот на проведение дорогостоящих исследований и операций, санаторно-курортное лечение, проведение диспансеризации и пр.)</li>\r\n\t<li>о вакцинации</li>\r\n\t<li>о лекарственных средствах (показания, противопоказания, &nbsp;аналоги)</li>\r\n\t<li>по организации получения платных услуг, если они не входят в программу ДМС, для Вас и Ваших близких.</li>\r\n</ul>\r\n',
		actionText: 'Задать вопрос',
	},
	[NAMES.GUARANTEE_LETTER]: {
		desktopImage: 'https://old.rgs.ru/upload/medialibrary/67b/dms_popup_banners_720x400_221121_ep.png',
		mobileImage: 'https://old.rgs.ru/upload/medialibrary/2df/dms_popup_banners_600x320_221121_ep.png',
		title: 'Запросить гарантийное письмо',
		text: 'Если для диагностики и лечения необходимо гарантийное письмо, Вы можете запросить его онлайн.<br><br>Также Вы можете обратиться в Медицинский контактный центр ПАО СК Росгосстрах по телефону или воспользоваться онлайн-чатом.',
		actionText: 'Согласовать диагностику и лечение',
	},
	[NAMES.PLANNED_HOSPITALIZATION]: {
		desktopImage: 'https://old.rgs.ru/upload/medialibrary/fb6/600x320_1_planovaya_gospitalizatsiya.jpg',
		mobileImage: 'https://old.rgs.ru/upload/medialibrary/c2d/720x400_1_planovaya_gospitalizatsiya.jpg',
		title: 'Оформить заявку на плановую госпитализацию',
		text: '<div class="padding-bottom-ms-1">Врач рекомендует Вам продолжить лечение в условиях стационара? </div><div class="padding-bottom-ms--4">Вы можете оформить заявку на организацию плановой госпитализации онлайн.</div>',
		actionText: 'Оформить заявку',
	},
	[NAMES.CALLING_DOCTOR]: {
		desktopImage: 'https://old.rgs.ru/upload/medialibrary/d5b/720x400_2_3_vyzov_vracha_na_dom.jpg',
		mobileImage: 'https://old.rgs.ru/upload/medialibrary/8ae/600x320_2_3_vyzov_vracha_na_dom.jpg',
		title: 'Вызвать врача на дом',
		text: '	Для вызова врача на дом Вы можете оформить заявку онлайн.',
		actionText: 'Подать заявку',
	},
	[NAMES.MEDICAL_CARE_ABROAD]: {
		desktopImage: 'https://old.rgs.ru/upload/medialibrary/6dd/720x400_3_2_pomoshch_za_rubezhom.jpg',
		mobileImage: 'https://old.rgs.ru/upload/medialibrary/8b5/600x320_3_2_pomoshch_za_rubezhom.jpg',
		title: 'Получить помощь за рубежом',
		text: '<div class="padding-bottom-ms-1">Находитесь в поездке за пределами Российской Федерации и Вам требуется получить медицинскую помощь?</div><div>Свяжитесь с круглосуточным центром помощи сервисной компании.</div>',
		actionText: 'Подать заявку на сайте',
		actionText2: 'Обратиться по телефону',
	},
	[NAMES.LABORATORY_RESEARCH]: {
		desktopImage: 'https://old.rgs.ru/upload/iblock/e85/i-2152342457-1.png',
		mobileImage: 'https://old.rgs.ru/upload/iblock/e85/i-2152342457-1.png',
		title: 'Сдать анализы',
		text: 'Врач рекомендовал сдать анализы?<br><br>Посетите лабораторию в удобном для Вас месте и в удобное для Вас время.',
		actionText: 'Выбрать лабораторию',
	},
};
/*eslint-enable max-len*/

export const AVAILABLE_SERVICES = {
	NAMES,
	STATUSES,
	MESSAGES,
	CONTENT,
};
